/**
 * Copyright ©2023 Drivepoint
 */

import React, {useImperativeHandle, useState} from "react";
import {Menu, MenuItem} from "@mui/material";
import Template from "../../utilities/Template";
import Logger from "../../utilities/logger/Logger";
import "./StandardMenu.less";

const logger = Logger.logger;

export type StandardMenuItem = {
  id: string;
  label: string;
  visible?: any;
};

export type StandardMenuProps = {
  items: StandardMenuItem[];
  onClick: (item: StandardMenuItem, data?: any) => void;
};

export type StandardMenuInterface = {
  open: (element: HTMLElement, data?: any) => void;
  close: () => void;
};

const StandardMenu = React.forwardRef<StandardMenuInterface, StandardMenuProps>((props: StandardMenuProps, ref: any): any => {

  useImperativeHandle(ref, (): StandardMenuInterface => ({
    open: (element: HTMLElement, data?: any): void => {
      setItems(getItems(data));
      setData(data);
      setAnchor(element);
    },
    close: () => close()
  }));

  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const [data, setData] = useState<any>();
  const [items, setItems] = useState<StandardMenuItem[]>([]);

  function getItems(data?: any): StandardMenuItem[] {
    if (!data) { return []; }
    return props.items.filter(item => {
      if (typeof item.visible === "string") { return Template.parse(item.visible, data) === "true"; }
      if (typeof item.visible === "boolean") { return item.visible; }
      return true;
    });
  }

  function close(): void {
    setAnchor(null);
    setItems([]);
    setData(null);
  }

  function onMenuItemClick(item: StandardMenuItem): void {
    close();
    props.onClick(item, data);
  }

  function renderMenuItem(item: StandardMenuItem): any {
    return <MenuItem key={`menu_item_${item.id}`} onClick={() => onMenuItemClick(item)} disableRipple>
      {Template.parse(item.label, data)}
    </MenuItem>;
  }

  return <Menu className="standard-menu" open={!!anchor} onClose={close} anchorEl={anchor}>
    {items.map(item => renderMenuItem(item))}
  </Menu>;

});

export default StandardMenu;
